export class PopupApi {
    path = '/adm/popups';

    async list(filters = null) {
        try {
            const response = await axios.get(`${this.path}/list`, {
                params: filters,
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching popup list:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            const response = await axios.get(`${this.path}/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching popup:', error);
            throw error;
        }
    }

    async store(data) {
        try {
            const response = await axios.post(`${this.path}`, data);

            return response.data;
        } catch (error) {
            console.error('Error store popup:', error);
            throw error;
        }
    }

    /**
     * @param {FormData|Object} data
     * @param {number|string} id
     * @param {{ multipart?: boolean }} options multipart: true envia POST + _method=PUT,
     * necessário porque o PHP não lê multipart/form-data em requisições PUT reais.
     */
    async update(data, id, { multipart = false } = {}) {
        try {
            if (multipart) {
                data.append('_method', 'PUT');

                const response = await axios.post(`${this.path}/${id}`, data);

                return response.data;
            }

            const response = await axios.put(`${this.path}/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error updating popup:', error);
            throw error;
        }
    }

    async destroy(id) {
        try {
            const response = await axios.delete(`${this.path}/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error deleting popup:', error);
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/api/PopupApi.js